<template>
  <v-container style="text-align: center;">
    <PageHeader
      header="Set Active Offsite Service"
      :subheader="activeService.name || 'No service selected'"
    />

    <SelectService
      class="mt-5"
      :resetToggle="resetToggle"
      @setSelectedId="setSelectedService"
    />

    <v-btn
      v-if="activeService.id"
      class="mt-10"
      color="primary"
      @click="resetService"
    >
      Reset Active Service
    </v-btn>
  </v-container>
</template>

<script>
import {
  GetActiveOffsiteService,
  SetActiveOffsiteService
} from "@/store/offsiteService";

import PageHeader from "@/components/PageHeader.vue";
import SelectService from "@/components/SelectService.vue";

export default {
  name: "SetActiveService",

  components: {
    PageHeader,
    SelectService
  },

  mounted() {
    this.activeService = GetActiveOffsiteService();
  },

  data: () => ({
    activeService: { id: null, name: null, schedule: null },
    resetToggle: false
  }),

  methods: {
    resetService() {
      SetActiveOffsiteService(null);
      this.activeService = { id: null, name: null, schedule: null };
      this.resetToggle = !this.resetToggle;
    },

    setSelectedService(details) {
      SetActiveOffsiteService(details);

      this.activeService = {
        id: details.id,
        name: details.serviceName,
        schedule: details.schedule
      };
    }
  }
};
</script>
